import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.0002 15.713L18.0102 9.70299L16.5972 8.28799L12.0002 12.888L7.40423 8.28799L5.99023 9.70199L12.0002 15.713Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronDown"
);
